import React, {RefObject, useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import { getLoyaltyProgramsActivities } from '../../../services/loyaltyProgramService'

export type CreditItem = {
  id: number;
  activity: string;
  creditEarningRate: string;
  notes: string;
  earnedCredits: string;
  isDeleted: boolean;
  createdAt: string;
  membershipPlan: null | number;
}

type Props = {
  refToScroll: RefObject<HTMLDivElement>
}

const MembershipCreditsWidget: React.FC<Props> = ({refToScroll}) => {
  const [rows, setRows] = React.useState<CreditItem[]>([])
  const history = useHistory()

  useEffect(() => {
    getActivities()
  },[])

  const getActivities = async () => {
    let rows = await getLoyaltyProgramsActivities();
    setRows(rows);
  }

  return (
    <div className='lp-shell mt-20' ref={refToScroll}>
      {/* Header Figma */}
      <div className='lp-hero'>
        <h2 className='lp-title'>Loyalty program</h2>
        <p className='lp-sub'>
          The loyalty program rewards active participation with credits that can cover up to 3 years
          of membership fees and offer discounts on experiences
        </p>
      </div>

      {/* Card */}
      <div className='lp-card lp-card--pad40 lp-card--outline'>
        <table className='lp-table'>
          <colgroup>
            <col style={{width: '40%'}} />
            <col style={{width: '27%'}} />
            <col style={{width: '33%'}} />
          </colgroup>

          <thead>
            <tr>
              <th>Activity</th>
              <th>Credit Earning Rate</th>
              <th>Notes</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((item, idx) => (
              <tr key={idx}>
                <td colSpan={3}>
                  <div className='lp-row-inner'>
                    <div className='lp-col lp-col-activity'>{item.activity}</div>
                    <div className='lp-col lp-col-rate'>{item.creditEarningRate}</div>
                    <div className='lp-col lp-col-notes'>{item.notes}</div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <button className="invite-member-modal-experience__action" onClick={()=>history.push('/logout')}>
          Logout
          {/* &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' /> */}
        </button>
      </div>
    </div>
  )
}

export {MembershipCreditsWidget}
